/* eslint-disable prettier/prettier */
import { Pause, Play } from 'lucide-react';
import React, { useState, useRef, useEffect } from 'react';
import ReactPlayer from 'react-player';
import { Dialog, DialogContent } from 'app/components/ui/dialog1';

const DialogVideoPlayer = ({ isOpen, setIsOpen, file }) => {
  const playerRef = useRef<ReactPlayer>(null);
  const [isPlaying, setIsPlaying] = useState(true);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <div className="text-white p-4">
          <h3 className="opacity-80 text-sm mb-2">Video Preview</h3>
          <div>
            <ReactPlayer
              ref={playerRef}
              url={file?.file_url}
              width="100%"
              height="100%"
              controls
              playing={isPlaying}
            />
            <p className="text-sm text-gray-400 mt-4">{file?.description}</p>

            {/* Play/Pause button */}
            <div
              className="w-16 h-16 bg-gray-800 rounded-full flex justify-center items-center absolute top-2/4 left-2/4 transform -translate-x-2/4 -translate-y-2/4"
              onClick={() => setIsPlaying(!isPlaying)}
            >
              <div className="relative w-16 h-16 bg-gray-800 rounded-full flex justify-center items-center">
                <div className="w-0 h-0 border-t-8 border-b-8 border-l-12 border-transparent border-l-white"></div>
                {isPlaying ? (
                  <div className="absolute text-white">
                    <Pause className="w-6 h-6" />
                  </div>
                ) : (
                  <div className="absolute text-white">
                    <Play className="w-6 h-6" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DialogVideoPlayer;
